export default "__VITE_ASSET__Erb5iEjB__"